"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const brain_1 = __importDefault(require("./brain"));
const communication_1 = __importDefault(require("./communication"));
const genius_1 = __importDefault(require("./genius"));
const lifeBase_1 = __importStar(require("./lifeBase"));
const management_1 = __importDefault(require("./management"));
const motivation_1 = __importDefault(require("./motivation"));
const position_1 = __importDefault(require("./position"));
const potential_1 = __importStar(require("./potential"));
const response_1 = __importDefault(require("./response"));
const vector_1 = __importDefault(require("./vector"));
/** All types list. */
exports.default = Object.freeze({
    brain: brain_1.default,
    communication: communication_1.default,
    genius: genius_1.default,
    lifeBase: lifeBase_1.default,
    lifeBaseCC: lifeBase_1.cc,
    management: management_1.default,
    motivation: motivation_1.default,
    position: position_1.default,
    potential: potential_1.default,
    potentialCC: potential_1.cc,
    response: response_1.default,
    vector: vector_1.default,
});
//# sourceMappingURL=index.js.map